import {
  Dialog,
  DialogTitle,
  DialogContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  IconButton,
  Box,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

// ----------------- SECTION CONFIGURATION -----------------
const sections = [
  {
    title: "Dataflow",
    fields: [
      {
        name: "Start Date",
        type: "date",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "-",
      },
      {
        name: "Completed Date",
        type: "date",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "-",
      },
      {
        name: "Receipt Upload",
        type: "file",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "-",
      },
      {
        name: "Report File ",
        type: "file",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "-",
      },
      {
        name: "Note",
        type: "textarea",
        required: "-",
        maxLength: "250",
        expiry: "No",
        options: "-",
      },
      {
        name: "Status",
        type: "dropdown",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "not started, In progress, Positive, unable to verify",
      },
      {
        name: "CExternal",
        type: "checkbox",
        required: "-",
        maxLength: "-",
        expiry: "No",
        options: "-",
      },
    ],
  },
  {
    title: "VFS",
    fields: [
      {
        name: "Appointment Date",
        type: "date",
        required: "-",
        maxLength: "-",
        expiry: "-",
        options: "-",
      },
      {
        name: "VFS Center",
        type: "text",
        required: "Yes",
        maxLength: "25",
        expiry: "-",
        options: "-",
      },
      {
        name: "Status",
        type: "dropdown",
        required: "-",
        maxLength: "-",
        expiry: "-",
        options: "-",
      },
      {
        name: "Note",
        type: "textarea",
        required: "-",
        maxLength: "-",
        expiry: "-",
        options: "-",
      },
    ],
  },
  {
    title: "VISA",
    subTabs: [
      {
        title: "VISA",
        fields: [
          {
            name: "Submission Place",
            type: "text",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
          {
            name: "Visa",
            type: "file",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
          {
            name: "Visa Expiry",
            type: "date",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
          {
            name: "Status",
            type: "dropdown",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
          {
            name: "Note",
            type: "textarea",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
        ],
      },
      {
        title: "Emigration",
        fields: [
          {
            name: "Start Date",
            type: "date",
            required: "-",
            maxLength: "-",
            expiry: "No",
            options: "-",
          },
          {
            name: "End Date",
            type: "date",
            required: "-",
            maxLength: "-",
            expiry: "No",
            options: "-",
          },
          {
            name: "Status",
            type: "dropdown",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
          {
            name: "Note",
            type: "textarea",
            required: "-",
            maxLength: "-",
            expiry: "-",
            options: "-",
          },
        ],
      },
    ],
  },
];

// ----------------- MAIN COMPONENT -----------------
export default function ProcessView({
  open,
  handleClose,
  selectedProcedure = {},
}) {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl">
      <DialogTitle sx={{ padding: "40px" }}>
        <Typography fontWeight="bold" sx={{ fontFamily: "Geist, sans-serif", fontSize:"30px" }}>
          {selectedProcedure?.RP_Name}
        </Typography>

        <IconButton
          edge="end"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
          sx={{
            position: "absolute",
            right: `10px`,
            top: "0px",
          }}
        >
          <CloseIcon sx={{ fontSize: "40px" }} />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {selectedProcedure?.stages.map((section, i) => (
          <Accordion
            key={i}
            defaultExpanded
            sx={{
              boxShadow: "none",
              border: "2px solid lightgrey",
              overflow: "auto",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                fontWeight="bold"
                sx={{ fontFamily: "Geist, sans-serif" }}
              >
                {i + 1}) {section?.RPS_Name}
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              {section.subProcedures
                ? section.subProcedures.map((subTab, j) => (
                    <Box key={j} mb={3}>
                      <Typography
                        fontWeight="bold"
                        mb={1}
                        sx={{ fontFamily: "Geist, sans-serif" }}
                      >
                        {`${i + 1}.${j + 1}`}) {subTab?.RSP_Name}
                      </Typography>
                      {renderTable(subTab.fields)}
                    </Box>
                  ))
                : renderTable(section.fields)}
            </AccordionDetails>
          </Accordion>
        ))}
      </DialogContent>
    </Dialog>
  );
}

// ----------------- RENDER TABLE -----------------
const renderTable = (fields) => (
  <Table size="small" sx={{ mt: 1 }}>
    <TableHead>
      <TableRow>
        <TableCell sx={{ minWidth: "150px", fontFamily: "Geist, sans-serif" }}>
          <strong>Name</strong>
        </TableCell>
        <TableCell sx={{ minWidth: "150px", fontFamily: "Geist, sans-serif" }}>
          <strong>Type</strong>
        </TableCell>
        <TableCell sx={{ minWidth: "150px", fontFamily: "Geist, sans-serif" }}>
          <strong>Required</strong>
        </TableCell>
        <TableCell sx={{ minWidth: "150px", fontFamily: "Geist, sans-serif" }}>
          <strong>Max Length</strong>
        </TableCell>
        <TableCell sx={{ minWidth: "150px", fontFamily: "Geist, sans-serif" }}>
          <strong>Select Options</strong>
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {fields.map((field, index) => (
        <TableRow key={index}>
          <TableCell>{field.RPF_Name ? field.RPF_Name : "-"}</TableCell>
          <TableCell>{field.RPF_Type ? field.RPF_Type : "-"}</TableCell>
          <TableCell>{field.RPF_IsRequired ? "Yes" : "No"}</TableCell>
          <TableCell>
            {field.RPF_MaxLength ? field.RPF_MaxLength : "-"}
          </TableCell>
          <TableCell>
            {field.RPF_ValidValues
              ? JSON.parse(field.RPF_ValidValues).join(", ")
              : "-"}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
